const DEFAULT_PORTAL_ROOT_ID = "cui-portal-root";
export {
  DEFAULT_PORTAL_ROOT_ID
};
//# sourceMappingURL=constants.js.map
